import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Podcast = function Podcast(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17.1189 18C19.4623 16.4151 21 13.7779 21 10.785 21 5.9333 16.9704 2 12 2s-9 3.9333-9 8.785C3 13.7779 4.5377 16.4151 6.8811 18m1.4786-4C7.5187 13.15 7 12.0086 7 10.7505 7 8.1271 9.2388 6 12 6s5 2.1271 5 4.7505c0 1.259-.5187 2.3995-1.3597 3.2495M12 22c-1.1046 0-2-.8954-2-2v-2c0-1.1046.8954-2 2-2s2 .8954 2 2v2c0 1.1046-.8954 2-2 2m1-11c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default Podcast;